export default {
  install(Vue, options) {
    this.vm = Vue
    Vue.$transform = (users, type) => {
      let result = users

      if (Array.isArray(users)) {
        result = users.map(user => {
          // call functions from below
          for (let i = 0; i < type.length; i++) {
            this[`transform${type[i]}`](user)
          }
          return user
        })
      } else {
        /*
         comes one user and call functions below
         */
        for (let i = 0; i < type.length; i++) {
          this[`transform${type[i]}`](users)
        }

        result = users
      }
      return result
    }
  },

  transformimage(user) {
    user.avatar = user.has_avatar ? `${this.vm.config.modules.crm.storage}${user.employer_avatar}` : ''
  },

  transformfullName(user) {
    user.full_name = this.vm.$fullName(user)
  },

  transformsubtitle(user) {
    user.subtitle = user.work_position ? user.work_position.title : ''
  },
}
